import {Layout} from '@/components/common';

export function NotFound() {
  return <Layout>Page Not Found</Layout>;
}
